// Kalendarz (MAPA 35-R4, 22.09): miesiąc z kropkami, przełącznik kont, okno dnia.
// Klucze trzymaj zgodne z en/appCalendar.ts.
//
// Rama copy: kalendarz mówi WYŁĄCZNIE o tym, co zaplanowane i co już wyszło z naszej
// strony — nigdy o tym, co się z postem stanie po publikacji. Stan posta to pigułka
// z jednym słowem; zaplanowany nie ma pigułki (reguły 5 i 30). Zdań objaśniających nie
// ma (reguła 8): zdanie stoi tylko w oknie decyzji, przy błędzie i jako wymóg prawny.
export const appCalendar = {
  topbar: {
    // Tytułem ekranu jest „Publikacja” (rama zakładek, sesja 35) — ten klucz niesie
    // wyłącznie nazwę widoku dla czytnika ekranu.
    title: 'Kalendarz',
    plan: 'Zaplanuj publikację',
  },
  // Reguła 24: stan CAŁEJ funkcji jako pigułka w wierszu tytułu ekranu.
  feature: {
    paused: 'publikowanie wstrzymane',
  },
  // Wiersz miesiąca: „dziś” i strzałki. `prevWeek` / `nextWeek` niesie jeszcze pasek
  // tygodnia Planera (`MonthCalendar` w wariancie `rail`) — umierają razem z nim.
  period: {
    today: 'dziś',
    prevMonth: 'Poprzedni miesiąc',
    nextMonth: 'Następny miesiąc',
    prevWeek: 'Poprzedni tydzień',
    nextWeek: 'Następny tydzień',
  },
  grid: {
    label: 'Miesiąc dzień po dniu',
    // Skróty dni tygodnia nad siatką kropek (od poniedziałku), mono 11 (MAPA 35-R4).
    weekdays: 'pn,wt,śr,cz,pt,so,nd',
    // Pasek tygodnia Planera (wariant `rail`); Kalendarz tygodnia już nie ma.
    weekLabel: 'Tydzień dzień po dniu',
    // Nazwa komórki dla czytnika zamiast legendy: „wt., 22 wrz, 6 postów”.
    dayWithPosts: '{date}, {posts}',
    // Dopisek do nazwy komórki „dziś” (runda 43-A): godzina jest daną pod kropkami.
    todayNext: 'dziś, następny post {time}',
    // Tryb przenoszenia (runda 43-C): wolne miejsca konta w dniu — nazwa komórki dla czytnika.
    freePlaces_one: '{n} wolne miejsce',
    freePlaces_few: '{n} wolne miejsca',
    freePlaces_many: '{n} wolnych miejsc',
    noFreePlaces: 'brak wolnych miejsc',
    // Liczba kont ponad trzy wiersze komórki na komputerze.
    moreAccounts_one: '+{n} konto',
    moreAccounts_few: '+{n} konta',
    moreAccounts_many: '+{n} kont',
  },
  // Przełącznik kont (arkusz na telefonie, menu 304 px na komputerze).
  accounts: {
    all: 'Wszystkie konta',
    title: 'Konto',
    // Nazwa kropki sygnału przy przełączniku.
    reauthDot: 'konto wymaga ponownego logowania',
  },
  // Jedna linia działania pod siatką (linia poranka, runda 43-A): liczniki biorą słowa
  // stanów z `status.*`, a „Zatwierdź” nie niesie liczby.
  action: {
    review: 'Zatwierdź',
    // Nazwy licznika-filtra dla czytnika (`?stan=`); na ekranie słowo stanu i liczba.
    filterState: 'Pokaż tylko: {status}',
    filterOff: 'Pokaż wszystkie stany',
  },
  day: {
    // Lista dnia pod paskiem tygodnia Planera (wariant `rail`).
    none: 'Brak postów tego dnia',
    posts_one: '{n} post',
    posts_few: '{n} posty',
    posts_many: '{n} postów',
    // Tytuł okna dnia na poziomie treści: „@nocna.zmiana · wt., 22 wrz”.
    accountTitle: '{account} · {date}',
    back: 'Wróć do kont',
    // Dzień „dziś” (runda 43-A): słowo przy linii „teraz” (godzina jest daną) i nazwa
    // następnej godziny w wierszu konta — tylko dla czytnika, na ekranie sama godzina.
    now: 'teraz',
    nextAt: 'następny {time}',
  },
  post: {
    expand: 'Rozwiń opis',
    collapse: 'Zwiń opis',
    editCaption: 'Edytuj opis',
    remove: 'Usuń z planu',
    // Sam czasownik; kwotę dokłada komponent kwoty (reguły 46 i 48).
    retry: 'Ponów',
    // Przeniesienie posta na inny termin (runda 43-C); tylko przy `can_move` z serwera.
    move: 'Przenieś',
    open: 'Otwórz na {platformLoc}',
    approve: 'Zatwierdź',
    // Post planu, którego nikt nie uruchomił: zgody z okna dnia serwer nie przyjmie
    // (409 `campaign_not_active`), więc droga prowadzi na zatwierdzenie PLANU (KB-03).
    approvePlan: 'Zatwierdź plan',
    // Powód nieudanego posta: JEDNO słowo albo dwa, bez zdania. Klucz = klasa błędu
    // z serwera (`publish_job.error_class`); nieznana klasa → `unknown`.
    reason: {
      platform_cap: 'limit platformy',
      daily_cap: 'limit dnia',
      min_gap: 'odstęp',
      past_due: 'faktura',
      connection_expired: 'konto rozłączone',
      connection_suspended: 'konto poza planem',
      privacy_unavailable: 'widoczność',
      rate_limited: 'tempo',
      auth_removed: 'dostęp cofnięty',
      provider_timeout: 'brak odpowiedzi',
      content_gate: 'treść',
      provider_quota: 'przepustowość',
      render_too_large: 'za duży plik',
      withdrawal_failed: 'wycofanie',
      feature_disabled: 'publikacja wyłączona',
      deferral_expired: 'po terminie',
      provider_rejected: 'odrzucony',
      // Klasy, które serwer pisze najczęściej (`dispatcher.classify_error`, `reconcile`);
      // bez nich najpospolitsza porażka mówiła „sprawdzamy” (przegląd G, KF-05).
      provider_unavailable: 'dostawca niedostępny',
      rejected: 'odrzucony',
      timeout: 'brak odpowiedzi',
      consent_missing: 'brak zgody',
      gems_on_hold: 'rozliczenie w toku',
      still_in_flight: 'w wysyłce',
      day_full: 'dzień pełny',
      unknown: 'sprawdzamy',
    },
  },
  // Pigułki stanu posta; zaplanowany nie ma pigułki.
  status: {
    published: 'opublikowany',
    awaiting: 'czeka na zgodę',
    failed: 'nie wyszedł',
    cancelled: 'anulowany',
    // `scheduled` NIE jest pigułką (reguły 5 i 30): to słowo istnieje wyłącznie dla
    // czytnika ekranu, w nazwie komórki miesiąca (przegląd G, KF-12).
    scheduled: 'zaplanowany',
  },
  caption: {
    // Licznik to DANA, nie zdanie.
    counter: '{n} / {max}',
    // Mały przycisk pod polem opisu: okno zmiennych, które TEN post umie podstawić.
    vars: '{ } Zmienne',
    // Wymóg prawny TikToka (strefa chroniona): zdanie nad stopką zamiast pola wyboru
    // (decyzja 2 koordynatora). Oba odnośniki te same, co w Composerze.
    legalTiktok: 'Zapis potwierdza, że masz prawa do muzyki i treści posta zgodnie z {music} oraz {branded}.',
    legalMusic: 'Potwierdzeniem wykorzystania muzyki TikTok',
    legalBranded: 'Zasadami treści promocyjnych',
    save: 'Zapisz i potwierdź',
    saveOnly: 'Zapisz opis',
    cancel: 'Anuluj',
    // Błąd bramy treści: jedno zdanie + kod (reguła 8).
    rejected: 'Tego opisu nie da się zapisać.',
    exitTitle: 'Wyjść bez zapisu?',
    exitStay: 'Zostań',
    exitLeave: 'Wyjdź',
  },
  remove: {
    title: 'Usunąć z planu?',
    body: 'Post nie wyjdzie, a edit zostaje w Editach.',
    when: 'Termin',
    account: 'Konto',
    refund: 'Zwrócone tokeny',
    cancel: 'Anuluj',
  },
  // Tryb przenoszenia i arkusz godzin (runda 43-C): pigułka stanu, dane, nazwy dla czytnika.
  move: {
    state: 'przenosisz',
    cancel: 'Anuluj',
    cancelSr: 'Anuluj przenoszenie',
    region: 'Przenosisz post',
    hour: 'Godzina',
    used: '{used} / {cap}',
    newDate: 'Nowy termin',
    submit: 'Przenieś',
    // Naprawa jednym stuknięciem z `next_free_at` / `earliest_at` (reguła 56).
    fix: 'Ustaw {when}',
    slotFree: '{time}',
    slotTaken: '{time}, niedostępna',
    // Zamiana z postem tego samego konta (klatka 43-C-04).
    swap: 'Zamień',
    slotSwap: '{time}, {title}, zamień',
    // Pigułka rozwijająca stepper minut w oknie planu (reguła 54).
    other: 'Inna',
  },
  retry: {
    title: 'Ponowić post?',
    whenLabel: 'Termin',
    when: 'dziś, najbliższe okno',
    // Pierwsza kolumna pasa 7 dni (runda 43-C, klatka 05).
    today: 'dziś',
  },
  // Toast = jeden fakt po akcji (reguła 7); kwotę dokłada komponent kwoty.
  toast: {
    removed: 'Usunięto z planu',
    captionSaved: 'Opis zapisany.',
    retried: 'Ponowiono post',
    // Termin z odpowiedzi serwera (ponowienie może przesunąć w wyścigu); bez terminu → `retried`.
    retriedAt: 'Ponowiono post · {date}',
    removeFailed: 'Nie udało się usunąć posta z planu.',
    retryFailed: 'Nie udało się ponowić posta.',
    saveFailed: 'Nie udało się zapisać opisu.',
    // Przeniesienie niczego nie pobiera: toast niesie sam termin z odpowiedzi serwera.
    moved: 'Przeniesiono · {date}',
    swapped: 'Zamieniono miejscami · {a} i {b}',
    moveFailed: 'Nie udało się przenieść posta.',
  },
  // Odpowiedź serwera ma sufit pozycji: pigułka jako dana, pełne zdanie dla czytnika.
  truncated: {
    shown: 'pokazano do {date}',
    full: 'Ten miesiąc ma więcej postów, niż mieści jedna odpowiedź: pokazujemy posty do {date}. Późniejsze dni mogą być niepełne.',
  },
  // Pusty miesiąc: glif, tytuł i JEDNA akcja (reguła 8).
  empty: {
    title: 'Brak postów w tym miesiącu',
  },
  // Błąd wczytania: jedno zdanie, droga naprawy, kod (`kalendarz-{status}`).
  error: {
    title: 'Nie udało się wczytać kalendarza.',
    retry: 'Spróbuj ponownie',
  },
  noAccounts: {
    title: 'Brak podłączonych kont',
    action: 'Podłącz konto',
  },
  // Stan „funkcja wyłączona” ma JEDNO zdanie na czterech zakładkach Publikacji:
  // `appCampaigns.disabled` (PROD1 FR-4).
}
